<template>
  <SkeletonTheme :color="isDarkMode ? '#444444' : '#eeeeee'">
    <div v-for="i in rows" :key="i" style="display: flex; margin-top: 20px">
      <PuSkeleton circle width="50px" height="50px" />
      <div style="flex-grow: 1; margin: 5px">
        <PuSkeleton :count="2" />
      </div>
    </div>
  </SkeletonTheme>
</template>

<script>
import { SkeletonTheme } from "vue-loading-skeleton"
import { mapGetters } from "vuex"
export default {
  props: ["rows"],
  components: {
    SkeletonTheme
  },
  computed: {
    ...mapGetters({ isDarkMode: "isDarkMode" })
  }
}
</script>
